import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-flex-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_KpiSchedulerFilterDetailCard = _resolveComponent("KpiSchedulerFilterDetailCard")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock("div", null, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.kpiNames, (kpiName, index) => {
      return (_openBlock(), _createBlock(_component_Card, {
        key: index,
        class: "p-mt-2"
      }, {
        header: _withCtx(() => [
          _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
            start: _withCtx(() => [
              _createTextVNode(_toDisplayString(kpiName), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        content: _withCtx(() => [
          _createVNode("div", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.formatedFilters[kpiName], (filter) => {
              return (_openBlock(), _createBlock(_component_KpiSchedulerFilterDetailCard, {
                class: "p-m-2",
                key: filter.id,
                filter: filter,
                placeholderType: _ctx.placeholderType,
                temporalType: _ctx.temporalType,
                lovs: _ctx.lovs,
                onTouched: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('touched')))
              }, null, 8, ["filter", "placeholderType", "temporalType", "lovs"]))
            }), 128))
          ])
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}